<template>
  <c-row>
    <c-col col="6">
      <loader v-show="loading" />
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Chant of Accounting</strong>
            <div class="card-header-actions">
              <a class="link btn btn-outline-success" @click="addNew">
                <i class="cil-plus"></i>
              </a>
            </div>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Code</th>
                  <th>Name</th>
                  <th style="width: 200px">Link</th>
                  <th></th>
                </tr>
              </thead>
              <tbody v-for="(d, k) in banks.data" :key="k">
                <tr>
                  <td :rowspan="d.children.length + 1">
                    <strong>{{ k + 1 }}</strong>
                  </td>
                  <td>
                    <strong>{{ d.code }}</strong>
                  </td>
                  <td>
                    <strong>{{ d.name }}</strong>
                  </td>
                  <td>
                    <strong v-if="links">
                      {{ links[d.link_to] }}
                    </strong>
                  </td>
                  <td>
                    <action-button
                      :object="d"
                      @doEdit="doEdit"
                      @actionDelete="actionDelete"
                    />
                  </td>
                </tr>
                <tr v-for="(c, ky) in d.children" :key="ky">
                  <td>{{ c.code }}</td>
                  <td>
                    <span>{{ c.name }}</span>
                  </td>
                  <td>
                    <span v-if="links">
                      {{ links[c.link_to] }}
                    </span>
                  </td>
                  <td>
                    <action-button
                      :object="c"
                      @doEdit="doEdit"
                      @actionDelete="actionDelete"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH } from '../../lib/httplib';
import ActionButton from '../../components/ActionButton'
import Loader from '../../components/Loader.vue';
export default {
  components: {
    'action-button': ActionButton,
    Loader,
  },
  data () {
    return {
      bank: {},
      banks: [],
      errors: [],
      loading: true,
      links: [],
    };
  },
  computed: {
  },
  created () {
    this.getCoa();
    this.getCoaLink();
  },
  methods: {
    getCoaLink () {
      this.loading = true
      HTTPAUTH.get(`/api/v1/coa/link/items`).then(res => {
        this.links = [];
        const data = res.data.data;
        for (var i in data) {
          this.links[data[i].key] = data[i].label
        }
      }).catch(eres => {
        this.$toasted.error(eres.response.data.user_message).goAway();
      })
    },
    getCoa () {
      this.loading = true
      HTTPAUTH.get(`/api/v1/coa/nested/items`).then(res => {
        this.banks = res.data;
        this.loading = false
      }).catch(eres => {
        this.loading = false
        this.$toasted.error(eres.response.data.user_message).goAway();
      })
    },
    actionDelete (o) {
      HTTPAUTH.delete("/api/v1/coa/" + o.id).then(() => {
        this.bank = {};
        this.getCoa();
      }).catch(eres => {
        if (eres.response.data.message) {
          this.$toasted.error(eres.response.data.message).goAway();
          this.errors = eres.response.data.errors;
          return;
        }
        this.$toasted.error(eres.response.data.user_message).goAway();
      })
    },
    addNew () {
      this.$router.push({ path: '/account/coa/add' }).catch(() => { })
    },
    doEdit (object) {
      this.$router.push({ path: '/account/coa/add', query: { id: object.id } }).catch(() => { })
      this.bank = object;
    }
  }
};
</script>